import { useContext } from "react";
import { ContactsAdapterContext } from "./adapter-context";
import type { ContactsAdapter } from "./types";

/** Read the active contacts adapter from context (mock in W3a). */
export function useContactsAdapter(): ContactsAdapter {
  return useContext(ContactsAdapterContext);
}
